import React from "react";
import {LoanData} from "../../model/LoanData";
import "../../../../app/tileable/instructions/component/Instructions.scss";
import {CallForHelpLink} from "../../../../app/tileable/instructions/contats/CallForHelpLink";
import {EmailForHelpLink} from "../../../../app/tileable/instructions/contats/EmailForHelpLink";
import {LoanType} from "../../model/LoanType";
import {LoanTypeUtil} from "../../../../util/LoanTypeUtil";
import {FeeOptionKey} from "../FeeSelector";

interface Props {
    loan: LoanData;
    selectedFees?: FeeOptionKey[];
}

export class LoanDetailsInstructions extends React.Component<Props> {
    //I love my Olenka <3


    render() {
        return <>

            <h1>Hi there, <br/>
                <span className="white-text">{this.props.loan.borrower.firstName}.</span>
            </h1>

            <p>Looks like you’re here to complete your <strong>{this.getPaymentType()}!</strong></p>

            <p>Check over your loan information real quick to make sure everything looks right, and then proceed to
                the
                payment page! </p>

            <p>Have questions? You can always <CallForHelpLink support={this.props.loan.support}>call</CallForHelpLink>
                &nbsp;or&nbsp;
                <EmailForHelpLink
                    support={this.props.loan.support}>email</EmailForHelpLink> {this.getPaymentAgent()} for help!
            </p>

        </>
    }

    private getPaymentType = () => {
        let type = this.props.loan.type;

        if (type === LoanType.ACH_LOAN) {
            return 'first loan payment';
        }

        if (type === LoanType.CREDIT_CARD_LOAN) {
            //todo refactor this
            if (this.props.selectedFees && this.props.selectedFees.length > 0) {
                if (this.props.selectedFees.length === 1) {
                    return this.props.selectedFees.includes("APPRAISAL") ? 'payment' : 'payment';
                } else {
                    return 'payment';
                }
            }

            if (this.props.loan.appraisalFeeEnabled && !this.props.loan.creditFeeEnabled) {
                return 'payment';
            } else if (!this.props.loan.appraisalFeeEnabled && this.props.loan.creditFeeEnabled) {
                return 'payment';
            }
            return 'payment';
        }

        return '';
    }

    private getPaymentAgent = () => {
        return LoanTypeUtil.supportAgentOf(this.props.loan);
    }


}
